export type JsonValue = null | boolean | number | string | JsonValue[] | { [key: string]: JsonValue };

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};

const looksEmpty = (raw: string) => {
  const s = raw.trim();
  return !s || s === '{}' || s === 'null' || s === '[]';
};

/**
 * COA data is typically a JSON blob serialized as a string.
 * Sometimes it may be double-encoded (a JSON string that contains JSON).
 * A past bug embedded the raw DB `data` string inside the COA object itself;
 * strip it so downstream components never see stale nested JSON.
 */
export const parseCoaData = (raw: string | null | undefined): Record<string, unknown> | null => {
  if (!raw) return null;
  if (looksEmpty(raw)) return null;

  try {
    const first = JSON.parse(raw);
    const value = typeof first === 'string' ? JSON.parse(first) : first;
    if (!isRecord(value)) return null;

    // Strip the embedded 'data' JSON string left by the double-encoding bug
    if (typeof value.data === 'string') {
      const { data: _, ...clean } = value;
      return clean;
    }

    return value;
  } catch {
    return null;
  }
};
